import isMobileJs from 'ismobilejs'
import some from 'lodash/some'

export const isMobileResult = isMobileJs(window.navigator)

const isAnyMobile = some(isMobileResult, (value) => value === true)

export default function isMobile() {
    return isAnyMobile
}
